export enum MetricContext {
  ACCOUNT = 'Account',
  ACTIVATE_SUBSCRIPTION = 'Activate Subscription',
  ACTIVE_PEOPLE = 'Active People',
  ACTIVITY_FEED = 'Activity Feed',
  ADD_PAYMENT_METHOD = 'Add Payment Method',
  BANNER = 'Banner',
  BILLING = 'Billing',
  BULK_RESPONSE_VIEW = 'Bulk Response View',
  CANDIDATE_MANAGEMENT = 'Candidate Management',
  CHAT = 'Chat',
  CHATS = 'Chats',
  COMPANY_BILLING_INFORMATION = 'Company Billing Information',
  COMPANY_PROFILE = 'Company Profile',
  COMPANY_REVIEWS_VIEW = 'Company Reviews View',
  CREATE_OPENING = 'Create Opening',
  CREATE_OPENING_INTERVIEW = 'Create Opening Interview',
  CREATE_OPENING_MESSAGE = 'Create Opening Message',
  CREATE_OPENING_PITCH = 'Create Opening Pitch',
  CREATE_OPENING_POST = 'Create Opening Post',
  CREATE_OPENING_REVIEW = 'Create Opening Review',
  CREATE_OPENING_TARGETING = 'Create Opening Targeting',
  DASHBOARD_PAGE = 'Dashboard Page',
  DEACTIVATE_OPENING = 'Deactivate Opening',
  END_CHAT = 'End Chat',
  FEATURED_APPLICANTS_VIEW = 'Featured Applicants View',
  FINISH_RECRUITER_PROFILE = 'Finish Recruiter Profile',
  FORGET_PASSWORD_PAGE = 'Forget Password Page',
  INVITING_COLLABORATORS = 'Inviting Collaborators',
  INVITING_TEAM_MEMBERS = 'Inviting Team Members',
  LOGIN_PAGE = 'Login Page',
  MAIN_NAVIGATION = 'Main Navigation',
  MARKET_OVERVIEW = 'Market Overview',
  NOTIFICATION_CENTER = 'Notification Center',
  OPENINGS_LIST = 'Openings List',
  OPENINGS_PAGE = 'Openings Page',
  OPENING_ACTIONS = 'Opening Actions',
  OPENING_CANDIDATES_VIEW = 'Opening Candidates View',
  OPENING_POTENTIAL_CANDIDATES_FEED = 'Opening Potential Candidates Feed',
  OPENING_SHARING = 'Opening Sharing',
  OPENING_VIEW = 'Opening View',
  PUBLISHED_OPENING_APPLICANTS_BULK_APPLY_VIEW = 'Published Opening Applicants Bulk Apply View',
  RECRUITER_PROFILE = 'Recruiter Profile',
  REGISTER_PAGE = 'Register Page',
  RESET_PASSWORD_PAGE = 'Reset Password Page',
  SENDING_FAST_TRACK = 'Sending Fast Track',
  SESSION = 'Session',
  SOURCE = 'Source',
  SOURCING_ENTRY_PAGE = 'Sourcing Entry Page',
  TALENT_ACTIVITY_PAGE = 'Talent Activity Page',
  TALENT_AGENT = 'Talent Agent',
  TALENT_AGENT_CANDIDATE_FEEDBACK_MODAL = 'Talent Agent Candidate Feedback Modal',
  TALENT_AGENT_FEED = 'Talent Agent Feed',
  TALENT_AGENT_PAGE = 'Talent Agent Page',
  TALENT_AGENT_SEND_MESSAGE_MODAL = 'Talent Agent Send Message Modal',
  TALENT_AGENT_USER_DETAILS_MODAL = 'Talent Agent User Details Modal',
  TALENT_AGENT_VIEW = 'Talent Agent View',
  TEAM_MEMBERS = 'Team Members',
  UPDATING_COMPANY_PROFILE = 'Updating Company Profile',
}

export enum MetricEventSource {
  ACTIVATE_OPENING_ACTION = 'Activate Opening Action',
  ACTIVATE_OPENING_BUTTON = 'Activate Opening Button',
  ADD_NEW_PAYMENT_METHOD_BUTTON = 'Add New Payment Method Button',
  APPLICANT_FOLLOWUP_CLICK = 'Applicant Follow-up Click',
  APPLICANT_ITEM = 'Applicant Item',
  APPLICANT_ITEM_CLICK = 'Applicant Item Click',
  APPLICANT_ITEM_LINKEDIN_ICON = 'Applicant Item LinkedIn Icon',
  APPLICANT_ITEM_RATING = 'Applicant Item Rating',
  APPLICANT_ITEM_REJECT_BUTTON = 'Applicant Item Reject Button',
  APPLICANT_ITEM_REPLY_BUTTON = 'Applicant Item Reply Button',
  ARCHIVE_OPENING_ACTION = 'Archive Opening Action',
  BACK_BUTTON = 'Back Button',
  BOTTOM_SECTION_BUTTON = 'Bottom Section Button',
  BULK_REJECT_BUTTON = 'Bulk Reject Button',
  BULK_REPLY_BUTTON = 'Bulk Reply Button',
  CANDIDATE_PROFILE_ARCHIVE_ACTION = 'Candidate Profile Archive Action',
  CANDIDATE_PROFILE_CLOSE_CHAT_ACTION = 'Candidate Profile Close Chat Action',
  CANDIDATE_PROFILE_LINKEDIN_ICON = 'Candidate Profile LinkedIn Icon',
  CANDIDATE_PROFILE_MARK_AS_UNREAD_ACTION = 'Candidate Profile Mark as Unread Action',
  CANDIDATE_PROFILE_REPORT_ACTION = 'Candidate Profile Report Action',
  CHATS_HEADER = 'Chats Header',
  CHATS_LIST_ITEM = 'Chats List Item',
  CLICK_ADD_TARGETING_BUTTON = 'Click Add Targeting Button',
  CLICK_TALENT_AGENT_USER = 'Click Talent Agent Verified User',
  CLICK_TALENT_AGENT_VIEW_ALL = 'Click Talent Agent View All',
  CONTINUE_BUTTON = 'Continue Button',
  COPY_LINK_BUTTON_OPENING_ITEM = 'Copy Link Button on Opening Item',
  COPY_LINK_BUTTON_OPENING_SHARING_SECTION = 'Copy Link Button Opening Sharing Section',
  DISCOVERY_SOURCING_PIPELINE = 'Discovery Sourcing Pipeline',
  DRAFT_OPENINGS_EMPTY_STATE = 'Draft Openings Empty State',
  DUPLICATE_OPENING_ACTION = 'Duplicate Opening Action',
  EDIT_INVOICING_DETAILS_BUTTON = 'Edit Invoicing Details Button',
  EXPORT_OPENING_CSV_ACTION = 'Export Opening CSV Action',
  FEED_ITEM_FOOTER_BUTTON = 'Feed Item Footer Button',
  INACTIVE_OPENINGS_EMPTY_STATE = 'Inactive Openings Empty State',
  INVITED_CANDIDATE_CLICK = 'Invited Candidates Click',
  LINKEDIN_ICON = 'LinkedIn Icon',
  MANAGE_COLLABORATORS_BUTTON = 'Manage Collaborators Button',
  OPENINGS_LIST_EMPTY_STATE_BUTTON = 'Openings List Empty State Button',
  OPENING_LIST_ITEM = 'Opening List Item',
  OPENING_SOURCING_PIPELINE = 'Opening Sourcing Pipeline',
  PAUSE_OPENING_ACTION = 'Pause Opening Action',
  PAUSE_OPENING_BUTTON = 'Pause Opening Button',
  POTENTIAL_CANDIDATE_CLICK = 'Potential Candidates Click',
  POTENTIAL_CANDIDATE_ITEM_LINKEDIN_ICON = 'Potential Candidates Item LinkedIn Icon',
  PUBLISH_BUTTON = 'Publish Button',
  REJECT_BUTTON = 'Reject Button',
  REOPEN_BUTTON_IN_INPUT_FIELD = 'Reopen Button in Message Input Field',
  REPLY_BUTTON = 'Reply Button',
  SEARCH_SOURCING_PIPELINE = 'Search Sourcing Pipeline',
  SEND_BUTTON_IN_INPUT_FIELD = 'Send Button in Message Input Field',
  SOCIAL_SHARE_BUTTON = 'Social Share Button',
  SOURCE_STARTING_SCREEN_SLIDE_BLUE_BUTTON = 'Source Starting Screen Slide Blue Button',
  SOURCE_STARTING_SCREEN_SLIDE_STEP = 'Source Starting Screen Slide Step',
  STOP_OPENING_ACTION = 'Stop Opening Action',
  STOP_OPENING_BUTTON = 'Stop Opening Button',
  SWITCH_PAYMENT_METHOD_TAB = 'Switch Payment Method Tab',
  TABLE_HEADER_BUTTON = 'Table Header Button',
  TAB_NAVIGATION = 'Tab Navigation',
  TOP_NOTICE_BAR = 'Top Notice Bar',
  TOP_SECTION_BUTTON = 'Top section Button',
  USER_LOGIN = 'User Login',
  VIEW_TALENT_AGENT_USER_MODAL = 'View Talent Agent User Modal',
}

/**
 * Please consider naming event with every word capitalized
 */
export enum MetricAction {
  ACCEPT_APPLICATION = 'Accept Application',
  ACTIVATE_OPENING = 'Activate Opening',
  ACTIVATE_SUBSCRIPTION = 'Activate Subscription',
  ADD_COMMENT = 'Add Comment',
  ADD_NEW_PAYMENT_METHOD = 'Add Payment Method',
  ARCHIVE_CHAT = 'Archive Chat',
  ARCHIVE_OPENING = 'Archive Opening',
  CANCEL_SUBSCRIPTION = 'Cancel Subscription',
  CHANGE_SLOTS_COUNT = 'Change Slots Count',
  CLICK_ADD_TARGETING_BUTTON = 'Click Add Targeting Button',
  CLICK_POTENTIAL_CANDIDATE_LINKEDIN_ICON = 'Click Potential Candidate LinkedIn Icon',
  CLICK_RECOMMENDED_USER_LINKEDIN_ICON = 'Click Recommended User LinkedIn Icon',
  CLICK_SOURCE_REVIEW_NEW_TALENTS = 'Click Source Review New Talents',
  CLICK_SOURCE_START_PITCHING = 'Click Source Start Pitching',
  CONFIRM_COLLABORATORS = 'Confirm Collaborators',
  CONNECT_POPUP_OPENED = 'Connect Popup Opened',
  COPY_PUBLIC_URL = 'Copy Public Url',
  COPY_TALENT_URL = 'Copy Talent Url',
  DEACTIVATE_OPENING = 'Deactivate Opening',
  DOWNGRADE_SUBSCRIPTION = 'Downgrade Subscription',
  END_CHAT = 'End Chat',
  EXPORT_CSV = 'Export CSV',
  FETCH_MORE = 'Fetch More',
  FILL_COMPANY_PROFILE_INFO = 'Fill Company Profile Info',
  FILL_FAST_TRACK_LINK = 'Fill Fast Track Link',
  FILL_PAYMENT_METHOD_INFO = 'Fill Payment Method Info',
  FILL_RECRUITER_PROFILE_INFO = 'Fill Recruiter Profile Info',
  FILTER_TALENT_AGENT_USERS = 'Filter Talent Agent Users',
  FINISH_RECRUITER_SIGNUP = 'Finish Recruiter Sign Up',
  INVITE_BULK_APPLICANTS = 'Invite Bulk Applicants',
  INVITE_TEAM_MEMBER = 'Invite Team Member',
  LEAVE_PUBLISHED_OPENING_APPLICANTS_BULK_APPLY_PAGE = 'Leave Published Opening Applicants Bulk Apply Page',
  LOAD_NEW_NOTIFICATIONS = 'Load New Notifications',
  LOAD_NEXT_DAY_BATCH = 'Load Next Day Batch',
  LOAD_PREVIOUS_DAY_BATCH = 'Load Previous Day Batch',
  LOG_OUT = 'Log Out',
  MAKE_CARD_PRIMARY = 'Make Card Primary',
  MARK_ALL_AS_READ = 'Mark All As Read',
  MARK_CHAT_AS_UNREAD = 'Mark Chat as Unread',
  MARK_NOTIFICATION_AS_READ = 'Mark As Read',
  NEGATIVE = 'Negative',
  OPENING_PUBLISHED = 'Opening Published',
  OPEN_ACTIVATE_SUBSCRIPTION = 'Open Activate Subscription View',
  OPEN_ADD_OPENING = 'Open Add Opening',
  OPEN_ADD_PAYMENT_METHOD_VIEW = 'Open Add Payment Method View',
  OPEN_BOOK_CALL_VIEW = 'Open Book a Call View',
  OPEN_BULK_RESPONSE_VIEW = 'Open Bulk Response View',
  OPEN_CANDIDATE_CHAT_VIEW = 'Open Candidate Chat View',
  OPEN_CANDIDATE_PROFILE_VIEW = 'Open Candidate Profile View',
  OPEN_CHATS = 'Open Chats',
  OPEN_COMPANY = 'Open Company',
  OPEN_COMPANY_REVIEWS = 'Open Company Reviews',
  OPEN_COMPENSATION_APP = 'Open Compensation App',
  OPEN_DEACTIVATE_OPENING = 'Open Deactivate Opening View',
  OPEN_DEACTIVATE_REASON_SURVEY = 'Open Deactivate Reason Survey View',
  OPEN_END_CHAT_VIEW = 'Open End Chat View',
  OPEN_FAST_TRACK_VIEW = 'Open Fast Track View',
  OPEN_FEATURED_APPLICANTS = 'Open Featured Applicants',
  OPEN_FEATURED_APPLICANT_MODAL = 'Open Featured Applicant Modal',
  OPEN_FINISH_RECRUITER_PROFILE_VIEW = 'Open Finish Recruiter Profile View',
  OPEN_HOME = 'Open Home',
  OPEN_INTERVIEW_VIEW = 'Open Interview View',
  OPEN_INVITE_TEAM_MEMBER = 'Open Invite Team Member View',
  OPEN_LINK = 'Open Link',
  OPEN_LINKEDIN = 'Open LinkedIn',
  OPEN_MANAGE_COLLABORATORS = 'Open Manage Collaborators View',
  OPEN_MESSAGE_VIEW = 'Open Message View',
  OPEN_NOTIFICATION = 'Open Notification',
  OPEN_NOTIFICATION_CENTER = 'Open Notification Center',
  OPEN_OPENINGS = 'Open Openings',
  OPEN_OPENING_VIEW = 'Open Opening View',
  OPEN_POST_VIEW = 'Open Post View',
  OPEN_PUBLIC_OPENINGS = 'Open Public Openings',
  OPEN_REGISTER_PAGE_SECOND_STEP = 'Open Register Page Second Step',
  OPEN_REVIEW_VIEW = 'Open Review View',
  OPEN_SAVED_TALENTS = 'Open Saved Talents',
  OPEN_SEARCH = 'Open Search',
  OPEN_SOURCE = 'Open Source',
  OPEN_TALENT_ACTIVITY = 'Open Talent Activity',
  OPEN_TALENT_AGENT = 'Open Talent Agent',
  OPEN_TARGETING_VIEW = 'Open Targeting View',
  OPEN_TEAM = 'Open Team',
  OPEN_UPDATE_PASSWORD_VIEW = 'Open Update Password View',
  POSITIVE = 'Positive',
  PUBLISH_COMPANY_PROFILE = 'Publish Company Profile',
  PUBLISH_OPENING = 'Publish Opening',
  REJECT_APPLICATION = 'Reject Application',
  REMOVE_CARD = 'Remove Card',
  REMOVE_SAVED_VERIFIED_TALENT = 'Remove Saved Verified Talent',
  REOPEN_CHAT = 'Reopen Chat',
  REPLY_REVIEW = 'Reply Review',
  REPUBLISH_OPENING = 'Republish Opening',
  REQUEST_PASSWORD_RESET = 'Request Password Reset',
  RESEND_INVITE_TO_TEAM_MEMBER = 'Resend Invite to Team Member',
  RESPOND_TO_APPLICANTS = 'Respond to Applicants',
  RESPOND_TO_CANDIDATE = 'Respond to Candidate',
  SAVE_VERIFIED_TALENT = 'Save Verified Talent',
  SEARCH_PLACES = 'Search Places',
  SELECT_CATEGORY = 'Select Category',
  SELECT_REASON = 'Select Reason',
  SELECT_SATISFACTION = 'Select Satisfaction',
  SELECT_SEARCH_PATTERNS = 'Select Search Pattern',
  SEND_CHAT_MESSAGE = 'Send Chat Message',
  SEND_FAST_TRACK_LINK = 'Send Fast Track',
  SEND_MESSAGE_TO_VERIFIED_TALENT = 'Sent Message To Verify Talent',
  SEND_REJECTION = 'Send Rejection',
  SET_ASSISTANCE_WITH_SALARY_BUDGET = 'Set Assistance With Salary Budget',
  SET_AUTOMATED_RESPONSE = 'Set Automated Response',
  SET_COLLABORATORS = 'Set Collaborators',
  SET_EMPLOYMENT_TYPE = 'Set Employment Type',
  SET_END_CHAT_MESSAGE = 'Set End Chat Message',
  SET_FAST_TRACK_IS_EXTERNAL_APPLICATION = 'Set Fast Track Is External Application',
  SET_FAST_TRACK_SALARY_RANGE = 'Set Fast Track Salary Range',
  SET_INVITEE_EMAIL = 'Set Invitee Email',
  SET_INVITEE_NAME = 'Set Invitee Name',
  SET_MESSAGE = 'Set Message',
  SET_OPENING_VISIBILITY = 'Set Opening Visibility',
  SET_PITCH_MESSAGE = 'Set Post Message',
  SET_POSITION_LOCATIONS = 'Set Position Locations',
  SET_POSITION_TITLE = 'Set Position Title',
  SET_POST_MESSAGE = 'Set Post Message',
  SET_QUESTIONS = 'Set Questions',
  SET_RELOCATION_PACKAGES = 'Set Relocation Packages',
  SET_REMOTE_WORKING = 'Set Remote Working',
  SET_RESPONSE_MESSAGE = 'Set Response Message',
  SET_SALARY_RANGE = 'Set Salary Range',
  SET_SENIORITY = 'Set Seniority',
  SET_SKILLS = 'Set Skills',
  SET_SPECIALTY = 'Set Speciality',
  SET_TARGET_LOCATIONS = 'Set Target Locations',
  SET_WORKLOAD = 'Set Workload',
  SIGN_UP_USER = 'Sign Up User',
  SKIP_PUBLISHED_OPENING_APPLICANTS_BULK_APPLY_PAGE = 'Skip Published Opening Applicants Bulk Apply Page',
  SOCIAL_SHARE = 'Social Share',
  SORT_FEED = 'Sort Feed',
  SUBSCRIBE = 'Subscribe',
  SWITCH_TO_NEW_SOURCING_EXPERIENCE = 'Switch To New Sourcing Experience',
  SWITCH_WORKSPACE = 'Switch Workspace',
  TALENT_ACTIVITY_VIEW = 'View Talent Activity Page',
  TALENT_AGENT_PAGE_VIEW = 'View Talent Agent Page',
  TOGGLE_SOCIAL_SHARING_PREFERENCE = 'Toggle Social Sharing Preference',
  UNFOLLOW_NOTIFICATION_ENTITY = 'Unfollow Notification Entity',
  UPDATE_RECRUITER_PROFILE = 'Update Recruiter Profile',
  UPGRADE_SUBSCRIPTION = 'Upgrade Subscription',
  USER_LOADED = 'User loaded',
  VIEW_DASHBOARD_PAGE = 'View Dashboard Page',
  VIEW_DIRECT_CONNECT_SECTION = 'View direct connect text area',
  VIEW_FEATURED_APPLICANTS_PAGE = 'View Featured Applicants Page',
  VIEW_FEATURED_APPLICANT_MODAL = 'View Featured Applicant Modal',
  VIEW_FORGET_PASSWORD_PAGE = 'View Forget Password Page',
  VIEW_LOGIN_PAGE = 'View Login Page',
  VIEW_OPENING_PAGE = 'View Opening Page',
  VIEW_PUBLIC_OPENING_PAGE = 'View Public Opening Page',
  VIEW_PUBLISHED_OPENING_APPLICANTS_BULK_APPLY_PAGE = 'View Published Opening Applicants Bulk Apply Page',
  VIEW_RECEIPT = 'View Receipt',
  VIEW_RECENTLY_ACTIVE = 'View Recently Active',
  VIEW_RECENTLY_JOINED = 'View Recently Joined',
  VIEW_RECENTLY_SAVED = 'View Recently Saved',
  VIEW_RECENTLY_VIEWED = 'View Recently Viewed',
  VIEW_RECOMMENDED_USER_DETAILS = 'View Recommended User Details',
  VIEW_REGISTER_PAGE = 'View Register Page',
  VIEW_RESET_PASSWORD_PAGE = 'View Reset Password Page',
  VIEW_SOURCE_PAGE = 'View Source Page',
  VIEW_SOURCE_PAGE_INITIAL_SLIDE = 'View Source Page Initial Slide',
  VIEW_SOURCE_PAGE_WELCOME_BACK_SLIDE = 'View Source Page Welcome Back Slide',
  VIEW_TOP_MATCHES = 'View Top Matches',
}

export const COMPANY_PROFILE_DICTIONARY = {
  officeImages: 'Office Images',
  productImages: 'Product Images',
};
